<template>
  <el-dialog class="noselect" :title="config.Title || title || '提示'" :visible.async="show" :width="config.Width || '550px'" :append-to-body="true" @close="handleClose" :class="IsDark ? 'Dark' : 'mx-dialog'">
    <slot></slot>
  </el-dialog>
</template>
<script>
export default {
  props: {
    value: Number,
    config: Object,
    title: String,
    loading: Boolean,
    numns: Number
  },
  computed: {
    IsDark() {
      return this.$matrix.Config.IsDark || false
    }
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    handleClose(e) {
      if (this.config.OnClose) {
        this.config.OnClose()
      }
    },
    handleClick(button) {
      //this.$emit("clickbutton", { name: e.Name });
      if (button && button.OnClick) {
        button.OnClick()
      }
    },
    handleOk(e) {
      if (this.config.OnOk) {
        this.config.OnOk()
      }
    },
    handleCancel(e) {
      if (this.config.OnCancel) {
        this.config.OnCancel()
      }
    }
  }
}
</script>
<style scope>
.Dark .el-dialog__header {
  background: #0b2846;
}
.Dark .el-dialog__title {
  color: #fff !important;
}
.Dark .el-dialog__body {
  background: #0b2846;
  color: #fff !important;
}
.Dark .el-dialog__footer {
  background: #0b2846;
}
/deep/.Dark .el-dialog .el-dialog__body .panel3 {
  background: #0b2846 !important;
}
/deep/.mx-dialog .el-dialog .el-dialog__body{
  padding:0 20px!important;
}
</style>
